export const portfolioReportLocation = "/domestic/portfolio"